/** Compare calendar dates in the viewer's local timezone, as Angular's date pipe does. */
export function messageTimeFormat(value: string, today: Date): string | null {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return null;
  }
  if (date.toDateString() === today.toDateString()) {
    return 'HH:mm';
  }
  return date.getFullYear() === today.getFullYear() ? 'dd.MM' : 'dd.MM.yyyy';
}

export interface MessageDay {
  key: string;
  date: Date;
  relative: 'today' | 'yesterday' | null;
}

export function messageDay(value: string, today: Date): MessageDay | null {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return null;
  }
  const yesterday = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
  return {
    key: `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`,
    date,
    relative:
      date.toDateString() === today.toDateString()
        ? 'today'
        : date.toDateString() === yesterday.toDateString()
          ? 'yesterday'
          : null,
  };
}
